import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appFormFieldHost]',
  standalone: false,
})
export class FormFieldAnchorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
